import { render, staticRenderFns } from "./imageInputFile.vue?vue&type=template&id=2a4b5232&scoped=true&"
import script from "./imageInputFile.vue?vue&type=script&lang=js&"
export * from "./imageInputFile.vue?vue&type=script&lang=js&"
import style0 from "./imageInputFile.vue?vue&type=style&index=0&id=2a4b5232&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4b5232",
  null
  
)

export default component.exports